import { PaletteOptions } from "@mui/material/styles/createPalette";
import colors from "./colors";

const palette: PaletteOptions = {
  primary: {
    main: colors.sapphire,
  },
  text: {
    primary: colors.black,
    secondary: colors.sapphire,
  },
};

export default palette;
